import type { MarketoFormInstance } from '../marketo-form.types';

/**
 * Removes all Marketo default styles and elements from the form
 */
export const removeMarketoStyles = (form: MarketoFormInstance): void => {
  const formEl = form.getFormElem()[0];

  // Remove all inline styles from the form and all its children
  const allElements = Array.from(formEl.querySelectorAll('*')).concat(formEl);
  allElements.forEach((element: Element) => {
    element.removeAttribute('style');
  });

  // Remove Marketo's injected style tags
  const styleTags = formEl.querySelectorAll('style');
  styleTags.forEach((styleTag: Element) => {
    styleTag.remove();
  });

  // Remove Marketo instruction spans
  const instructionSpans = formEl.querySelectorAll('.mktoInstruction');
  instructionSpans.forEach((span: Element) => {
    span.remove();
  });

  // Remove Marketo clear divs
  const clearDivs = formEl.querySelectorAll('.mktoClear');
  clearDivs.forEach((div: Element) => {
    div.remove();
  });

  // Remove Marketo offset divs
  const offsetDivs = formEl.querySelectorAll('.mktoOffset');
  offsetDivs.forEach((div: Element) => {
    div.remove();
  });

  // Remove Marketo gutter divs
  const gutterDivs = formEl.querySelectorAll('.mktoGutter');
  gutterDivs.forEach((div: Element) => {
    div.remove();
  });

  // Mark that styles have been removed
  formEl.setAttribute('data-custom-styles-applied', 'true');
};

/**
 * Disables Marketo's default stylesheets
 */
export const disableMarketoStylesheets = (): void => {
  const baseStyle = document.getElementById('mktoForms2BaseStyle') as HTMLLinkElement | null;
  const themeStyle = document.getElementById('mktoForms2ThemeStyle') as HTMLLinkElement | null;

  if (baseStyle) {
    baseStyle.disabled = true;
  }
  if (themeStyle) {
    themeStyle.disabled = true;
  }
};
